module.exports = __webpack_public_path__ + "_privacy.html";